module.exports = __webpack_public_path__ + "static/img/new-course-cover.326c7490.jpg";